import ModalManager from 'global/modal/ModalManager';
import * as model from 'global/shoppingLists/shoppingListsModel';

const { FormControl } = window.od;
const shoppingListData = {};

class ShoppingListModalManager extends ModalManager {
	constructor(entries) {
		super();
		shoppingListData.entries = entries;
	}

	setupResponseHtml(data) {
		super.setupResponseHtml(data);
		shoppingListData.instance = this;
		shoppingListData.responseHtml = this.responseHtml;

		if (
			shoppingListData.responseHtml.querySelectorAll('#shoppingListsForm')
				.length
		) {
			currentListTrigger();
		}
	}

	addModal() {
		super.addModal();

		setupForm();
	}

	replaceModalContent() {
		super.replaceModalContent();

		setupForm();
	}
}
class CreateShoppingListFormControl extends FormControl {
	attachFormEvents() {
		return false;
	}

	onSubmit(event) {
		return new Promise(resolve => {
			event.preventDefault();
			resolve(this.validateForm());
		});
	}
}

export default class ShoppingLists {
	constructor(options = {}) {
		const parent = options.parent || document;

		this.shoppingListButton = parent.querySelectorAll('[data-add-to-list]');
		this.shoppingListModalId = 'shoppingLists';

		if (this.shoppingListButton.length) {
			this.modalTrigger();
		}
	}

	modalTrigger() {
		for (let i = 0; i < this.shoppingListButton.length; i += 1) {
			this.shoppingListButton[i].addEventListener('click', evt => {
				this.trigger = evt.target;

				this.populateShoppingListModal();
			});
		}
	}

	populateShoppingListModal() {
		return model.getShoppingLists().then(result => {
			const { data } = result;
			this.entriesData = {
				entriesSource: this.entriesSource(),
			};

			if (this.entriesData.entriesSource === 'REQUEST_LIST') {
				this.entriesData.listEntries = this.selectedProducts();
			}

			this.modalInstance = new ShoppingListModalManager(this.entriesData);
			this.modalInstance.insertResponse(data, this.shoppingListModalId);
		});
	}

	entriesSource() {
		return this.trigger.getAttribute('data-source') || 'REQUEST_LIST';
	}

	selectedProducts() {
		return this.trigger.getAttribute('data-add-to-list') === 'single'
			? this.getSingleProduct()
			: this.getMultipleProducts();
	}

	getSingleProduct() {
		return [
			{
				code: this.trigger.getAttribute('data-code'),
				quantity: 1,
			},
		];
	}

	getMultipleProducts() {
		const productList = Array.from(document.querySelectorAll('[data-code]'));

		return productList.map(product => ({
			code: product.getAttribute('data-code'),
			quantity: 1,
		}));
	}
}

const setupForm = () => {
	const form = getForm();

	if (form) {
		shoppingListData.createForm = new CreateShoppingListFormControl(form);
		shoppingListData.createForm.form.addEventListener('submit', event => {
			shoppingListData.createForm.onSubmit(event).then(canSubmit => {
				if (canSubmit) {
					createShoppingListName();
				}
			});
		});
	}
};

const getForm = () => document.getElementById('addToShoppingListForm');

const currentListTrigger = () => {
	const currentShoppingLists = shoppingListData.responseHtml.querySelectorAll(
		'.shopping-list button',
	);

	if (currentShoppingLists) {
		for (let i = 0; i < currentShoppingLists.length; i += 1) {
			currentShoppingLists[i].addEventListener('click', event =>
				onListSelected(event),
			);
		}
	}
};

const onListSelected = event => {
	shoppingListData.shoppingListName = event.target.getAttribute('data-name');
	updateTargetList();
	event.preventDefault();
};

const updateTargetList = () => {
	const { shoppingListName } = shoppingListData;
	const listData = Object.assign({}, shoppingListData.entries, {
		shoppingListName,
	});

	return model.addOrCreateList(JSON.stringify(listData)).then(result => {
		const { data } = result;

		shoppingListData.instance.modal.hide();
		shoppingListData.instance.insertResponse(data, 'addedToShoppingList');
	});
};

const createShoppingListName = () => {
	shoppingListData.shoppingListName = document
		.getElementById('newShoppingListInput')
		.value.trim();

	if (shoppingListData.shoppingListName) {
		updateTargetList();
	}
};
